import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  UserControllerGetConfigRemoteMethod
} from 'open-api-legacy/remote-methods/user-controller-get-config.remote-method';
import { UserControllerGetConfigResponse } from 'open-api-legacy/responses/user-controller-get-config.response';

@Injectable({ providedIn: 'root' })
export class FeatureStatusService {
  private readonly getFeatureStatus = inject(UserControllerGetConfigRemoteMethod);
  public readonly status = new BehaviorSubject<UserControllerGetConfigResponse | null>(null);

  constructor() {
    this.getFeatureStatus.call().then(status => {
      this.status.next(status)
    });
  }
}
